<template>
  <div>
    <b-menu v-if="categories">
      <form @submit="handleSearch" class="mb-5">
        <b-field custom-class="w-100" expanded>
          <b-input placeholder="Search encyclopedia..." type="search" v-model="keyword" expanded></b-input>
          <p class="control">
            <b-button type="is-primary" native-type="submit" icon-right="search" />
          </p>
        </b-field>
      </form>

      <b-menu-list>
        <b-menu-item
          v-for="category in categories"
          :key="category.id"
          tag="router-link"
          :to="`/encyclopedia/${category.id}`"
          :active="isCategorySelected(category.id)"
          :expanded="isCategorySelected(category.id)"
          style="font-size: 14px;"
        >
          <template #label="props">
            {{ category.name }}
            <b-icon class="is-pulled-right" :icon="props.expanded ? 'chevron-down' : 'chevron-right'"></b-icon>
          </template>

          <b-menu-item
            class="is-size-7"
            v-for="subcategory in category.categories"
            :key="subcategory.id"
            tag="router-link"
            :to="`/encyclopedia/${category.id}/${subcategory.id}`"
            :label="`${subcategory.name}`"
            :active="isSubcategorySelected(subcategory.id)"
          />
        </b-menu-item>
      </b-menu-list>
    </b-menu>

    <b-loading :is-full-page="false" v-model="loadingCategories"></b-loading>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'navigation',
  computed: {
    ...mapState('encyclopedia', ['loadingCategories', 'categories']),
    mainCategory() {
      const segments = this.getUrlSegments();

      return segments[2] || null;
    },
    subCategory() {
      const segments = this.getUrlSegments();

      return segments[3] || null;
    },
  },
  data() {
    return {
      keyword: '',
    };
  },
  methods: {
    getUrlSegments() {
      return this.$route.path.split('/');
    },
    isCategorySelected(categoryId) {
      return categoryId === this.mainCategory;
    },
    isSubcategorySelected(categoryId) {
      return categoryId === this.subCategory;
    },
    handleSearch(event) {
      event.preventDefault();

      this.keyword = this.keyword.trim();

      if (this.keyword.length < 3) {
        this.errors = ['Please enter something longer to search for'];

        return;
      }

      this.$router.push({ path: `/encyclopedia/search/${this.keyword.trim()}` });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
